exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#generateAd .v--modal-box.v--modal{min-width:600px;min-height:270px}#generateAd *{font-size:12px}#generateAd .v-text-field__slot textarea{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e851e6b6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/analysis/modals/GenerateAd.vue
// module id = 1753
// module chunks = 0